// Helper para buscar endereço via CEP (ViaCEP) e preencher formulário

export interface ViaCepResp {
  cep: string
  logradouro: string
  complemento: string
  bairro: string
  localidade: string  // cidade
  uf: string
  ibge: string        // codigo IBGE da cidade
  unidade: string
  estado: string
  regiao: string
  ddd: string
  erro?: boolean
}

export async function buscarCep(cep: string): Promise<ViaCepResp | null> {
  const clean = (cep || '').replace(/\D/g, '')
  if (clean.length !== 8) return null
  try {
    const r = await fetch(`https://viacep.com.br/ws/${clean}/json/`)
    if (!r.ok) return null
    const data = await r.json()
    if (data.erro) return null
    return data as ViaCepResp
  } catch {
    return null
  }
}

// Código IBGE da UF (dos 2 primeiros dígitos do código da cidade)
export function codigoIbgeUf(codigoCidade: string): string {
  return (codigoCidade || '').substring(0, 2)
}
